import React from "react";
import { Respuestas } from "./Respuestas";
import { Box, Stack, Typography } from "@mui/material";
import { CuestionContext } from "../context/CuestionContext";
import { useContext } from "react";
import Parser from 'html-react-parser';
import ejeFinalizado from "../images/ejeFinalizado.png"
import "../styles/MisCuestionarios.css"

export function Preguntas({ pregunta }) {
  const { t } = useContext(CuestionContext)

  return (
    <>
      {pregunta ? (
        <Stack spacing={4}>
          <Stack direction={"row"} spacing={2}>
            <Typography variant="h5" color="text.black">
              {pregunta.texto && Parser(pregunta.texto)}
            </Typography>
          </Stack>
          <Respuestas />
        </Stack>
      ) : (
        <Stack direction={{xs: 'column', sm: 'column', md:'row'}} spacing={4} alignItems={"center"} >
          <Box sx={{ width: '60%', height: 'auto', marginBottom: "2em" }}>
            <img src={ejeFinalizado} alt="Descripción de la imagen" width="100%" height="auto" />
          </Box>
          <Stack spacing={4} marginBottom={{xs:"1em"}} textAlign={"justify"}>
            <Typography variant="h3" color="primary">
                {t('cuestion.ejeFinalizadoTitulo')} 
            </Typography>
            <Typography variant="h5" color="primary">
                {t('cuestion.ejeFinalizadoTexto')}              
            </Typography>
          </Stack>
        </Stack>
      )}
    </>
  );
}
